/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

/* eslint no-lonely-if: "off" */
import { IMultiAxisDatasetVisitor } from '../../../../store/types/MultiAxisDatasetTypes';

interface IMissingIndexVisitorContext {
    indexStack: number[],
    currentIndex: number,
    missingIndex: number
}

const missingIndexVisitor: IMultiAxisDatasetVisitor<IMissingIndexVisitorContext> = {
    preVisitNode(node, ctxt) {
        const context = ctxt;
        if (context.missingIndex < 0) {
            if (node.index < 0) {
                context.indexStack.push(context.currentIndex + 1)
            }
        }

        return context;
    },
    postVisitNode(node, ctxt, depth) {
        const context = ctxt;
        if (context.missingIndex < 0) {
            if (node.index < 0) {
                const visited = context.indexStack.pop() as number;
                if (node.isTotal) {
                    if (node.children.length) {
                        if (node.children[0].isFirst) {
                            if (node.children[node.children.length - 1].isLast) {
                                // everything is here, no-op
                            } else {
                                context.missingIndex = context.currentIndex;
                            }
                        } else {
                            context.missingIndex = visited;
                        }
                    }
                } else {
                    if (node.expanded) {
                        if (node.children.length) {
                            if (node.children[0].isFirst) {
                                if (node.children[node.children.length - 1].isLast) {
                                    if (node.total || node.children[0].isMeasure) {
                                        // everything is here, no-op
                                    } else {
                                        context.missingIndex = context.currentIndex;
                                    }
                                } else {
                                    context.missingIndex = context.currentIndex;
                                }
                            } else {
                                context.missingIndex = visited;
                            }
                        } else {
                            context.missingIndex = visited;
                        }
                    } else {
                        if (node.children.length && node.children[0].isMeasure) {
                            if (node.children[0].isFirst) {
                                if (node.children[node.children.length - 1].isLast) {
                                    // everything is here, no-op
                                } else {
                                    context.missingIndex = context.currentIndex;
                                }
                            } else {
                                context.missingIndex = visited;
                            }
                        } else {
                            if (node.total) {
                                // everything is here, no-op
                            } else {
                                context.missingIndex = visited;
                            }
                        }
                    }
                }
            } else {
                context.currentIndex += 1;
            }
        }
        return context;
    },

    postVisit(ctxt) {
        const context = ctxt;
        if (context.currentIndex === -1 && context.missingIndex === -1) {
            context.missingIndex = 0;
        }
        return context;
    }
};

export default missingIndexVisitor;
